import {hot} from 'react-hot-loader/root';
import React from 'react';
import {Redirect, Route, BrowserRouter as Router, Switch} from 'react-router-dom';

import {getRoutes, home, expiredPassword} from 'iss/routes';
import {pathLogin, pathLogout, pathLoggedOut} from 'iss/paths';
import {ProvideRoutes, useRoutes} from 'iss/hooks/useRoutes';
import LoginForm from 'iss/pages/LoginForm';
import AppStoreLinksPage from 'iss/pages/AppStoreLinksPage';
import LoggedOutPage from 'iss/pages/LoggedOutPage';
import {isPartyFetchInProgress, logout, subscribeToCurrentParty} from 'iss/service/PartyService';
import {RequestLoadingIndicator} from 'iss/widgets/LoadingIndicator';
import Navigation from 'iss/widgets/Navigation';
import {roles} from 'iss/service/PartyService';
import * as aad from 'iss/utils/azureAd';
import TitleBar from './widgets/TitleBar';
import {log} from 'iss/service/LogService';

require('iss/styles/global.styl');

window.onerror = (event, source, lineno, colno, error) => {
  // eslint-disable-next-line no-unused-vars
  log(error.message, error.stack).subscribe(() => {}, err => {
    // handle error to avoid loop
  });
  return true;
};

const LogoutComponent = () => {
  // In the case of AAD logout will eventually redirect to /logged-out. In the meanwhile display nothing.
  const aadLogin = aad.isSignedIn();
  window.setTimeout(logout, 10);
  return aadLogin ? null : <Redirect to={pathLogin} />;
};

function Container({children}) {
  const {location} = useRoutes();
  return <div data-route-location={location.pathname} className="container mainContent">
    {children}
  </div>;
}

const AppComponent = subscribeToCurrentParty(function render({party}) {
  /*
  In order not to fail due to race-condition between redirection here and sign in code elsewhere,
  pass any URI hash to the redirected URI. MSAL needs redirectUri hash, and errors if it is missing.
  https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/0e04ce3b0f93f001900d1056fc22bc18658a1bcb/lib/msal-browser/src/interaction_handler/PopupHandler.ts#L63
  */
  const redirectToLogin = <Route render={props => {
      return <Redirect to={pathLogin + props.location.hash} />;
  }} />;
  const redirectWhenNotLoggedIn = !party && !isPartyFetchInProgress() && !aad.isSignedIn()
                                    ? redirectToLogin : null;
  const redirectWhenPasswordExpired = !!party && party.roles.includes(roles.EXT_TEMPORARY_USER)
                                        ? <Redirect to={expiredPassword}/> : null;
  const redirectToHome = (party) ? <Redirect exact={true} from="/" to={home} /> : null;

  return <Router>
    <ProvideRoutes>
      {party && window.location.pathname !== '/app' ? <Navigation party={party} /> : <TitleBar/>}
      <Container>
        <Switch>
          <Route path="/app" component={AppStoreLinksPage}/>
          <Route path={pathLogin} component={LoginForm}/>
          <Route path={pathLogout} component={LogoutComponent}/>
          <Route path={pathLoggedOut} component={LoggedOutPage}/>
          {party
            ? getRoutes(party)
              .filter(route => route.path !== undefined)
              .map((route) => (<Route key={route.path} {...route} exact={true} />))
            : redirectWhenNotLoggedIn
          }
          {redirectWhenPasswordExpired}
          {redirectToHome}
        </Switch>
      </Container>
      <RequestLoadingIndicator id="loading"/>
    </ProvideRoutes>
  </Router>;
});

export default hot(AppComponent);



// WEBPACK FOOTER //
// ./modules/issFrontend/AppComponent.jsx